import React, { useState, useRef, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AiFillStar } from 'react-icons/ai';
import TripAdvisor from '../../TripAdvisor'; // Adjust the import path as needed
import { HotelType } from '../../../../../backend/src/shared/types'; // Adjust the import path as needed
import LinkButton from '../../Common/LinkButton';
import { useSearchContext } from '../../../contexts/SearchContext';
// import { PerNightPrice } from '../HotelPriceComponent';
// import { useSearchContext } from '../../contexts/SearchContext';

type Props = {
  hotels: HotelType[];
};

const CoupleSlider: React.FC<Props> = ({ hotels }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slidesRef = useRef<(HTMLDivElement | null)[]>([]);
  // const { checkIn, checkOut, adultCount, childCount } = useSearchContext();

  const location = useLocation();
  const hideOnRoutes = ['/couple-holidays'];
  const showButton = !hideOnRoutes.includes(location.pathname);
  const search = useSearchContext();

  const coupleHotels = hotels.filter(hotel => hotel.type.includes('Couple') &&
    hotel.country.includes('Mauritius')
  )
    .slice(0, 5);

  const handlePrev = useCallback(() => {
    setCurrentSlide(prev => (prev - 1 + coupleHotels.length) % coupleHotels.length);
  }, [coupleHotels.length]);

  const handleNext = useCallback(() => {
    setCurrentSlide(prev => (prev + 1) % coupleHotels.length);
  }, [coupleHotels.length]);

  return (
    <>
      {coupleHotels.length === 0 ? (
        ""
      ) : (
        <div className="min-h-[600px] py-8">
          <div className="relative border-2 border-gray-200 rounded-lg shadow-md overflow-hidden h-[550px]">
            <div className="relative h-full">
              {coupleHotels.map((hotel, index) => {
                const searchParams = new URLSearchParams({
                  checkIn: search.checkIn.toISOString(),
                  checkOut: search.checkOut.toISOString(),
                  adultCount: search.adultCount.toString(),
                  childCount: search.childCount.toString(),
                  childAges: JSON.stringify(search.childAges),
                  roomCount: search.roomCount.toString(),
                  nights: search.nights.toString(),
                  vacationType: search.vacationType,
                  hotelId: hotel.id,
                }).toString();
                return (
                  <div
                    key={hotel._id}
                    className={`absolute inset-0 transition-opacity duration-700 ${
                      index === currentSlide ? "opacity-100 z-10" : "opacity-0"
                    }`}
                    ref={(el) => (slidesRef.current[index] = el)}
                  >
                    {/* Hotel Image */}
                    <div
                      className="h-[300px] bg-cover bg-center w-full"
                      style={{
                        backgroundImage: `url(${hotel.imageUrls[0]})`,
                      }}
                    ></div>

                    {/* Hotel Info */}
                    <div className="p-4 flex flex-col justify-between h-[250px]">
                      <div className="flex-grow">
                        <div className="flex justify-between items-center mt-3 -mb-1">
                          <div className="flex">
                            {Array.from({ length: hotel.starRating }).map(
                              (_, index) => (
                                <AiFillStar
                                  key={index}
                                  className="text-yellow-400"
                                />
                              )
                            )}
                          </div>
                          <div>
                            <TripAdvisor
                              rating={hotel.tripRating}
                              maxRating={5}
                            />
                          </div>
                        </div>

                        <div className="flex justify-between mt-2">
                          <Link to={`/resort/${hotel.slug}?${searchParams}`} target="_blank" rel="noopener noreferrer">
                            <div className="text-black text-lg font-bold mb-4 leading-tight">
                              {hotel.name}
                            </div>
                          </Link>
                        </div>

                        <div className="flex items-center mb-2">
                          {" "}
                          {/* Add margin bottom for spacing */}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            className="h-3 w-3 mt-1 mr-2"
                            fill="currentColor"
                          >
                            <path
                              d="M256 0C153.755 0 70.573 83.182 70.573 185.426c0 126.888 165.939 313.167 173.004 321.035 6.636 7.391 18.222 7.378 24.846 0 7.065-7.868 173.004-194.147 173.004-321.035C441.425 83.182 358.244 0 256 0zm0 278.719c-51.442 0-93.292-41.851-93.292-93.293S204.559 92.134 256 92.134s93.291 41.851 93.291 93.293-41.85 93.292-93.291 93.292z"
                              fill="#d90062"
                            />
                          </svg>
                          <span className="font-normal mt-1">
                            {hotel.city}, {hotel.country}
                          </span>
                        </div>

                        <div className="flex items-center">
                          <img
                            src="/featureIcons/hotel_new.svg"
                            className="h-3 w-3 mt-1 mr-2"
                            alt="Hotel Icon"
                          />
                          <span className="font-normal mt-1">Hotel Only</span>
                        </div>

                        {/* <div className="flex items-center bg-green-100 p-2 mt-2">
                        <img
                          src="../featureIcons/deposit-secure.svg"
                          alt="Secure Deposit"
                          loading="lazy"
                          className="w-4 h-4 mr-2"
                        />
                        <span className="font-light">
                          Secure with deposit of just ${hotel.depositPrice}pp!
                        </span>
                      </div> */}
                      </div>

                      {/* Explore Deal Button */}
                      <div className="mt-4">
                        <Link
                          to={`/resort/${hotel.slug}?${searchParams}`}
                          target="_blank" rel="noopener noreferrer"
                          className="flex items-center justify-center bg-halo-pink text-white h-[40px] w-full cursor-pointer hover:bg-pink-800 rounded-sm"
                        >
                          Explore Offer
                          <img
                            src="../featureIcons/loupe.svg"
                            alt="Explore"
                            loading="lazy"
                            className="w-4 h-4 ml-2"
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}

              {/* Navigation Arrows (Outside of the Box) */}
              <button
                onClick={handlePrev}
                className="absolute w-[48px] h-[48px] left-2 top-1/2 -translate-y-1/2 rounded-full bg-gray-200 shadow-lg flex items-center justify-center z-20"
                aria-label="Previous"
              >
                <img
                  className=""
                  src="../featureIcons/left-chevron.svg"
                  loading="lazy"
                  alt="Previous"
                />
              </button>
              <button
                onClick={handleNext}
                className="absolute w-[48px] h-[48px] right-2 top-1/2 -translate-y-1/2 bg-gray-200 rounded-full shadow-lg flex items-center justify-center z-20"
                aria-label="Next"
              >
                <img
                  className="ml-1"
                  src="../featureIcons/chevron.svg"
                  loading="lazy"
                  alt="Next"
                />
              </button>
            </div>
          </div>

          {/* View All Deals Button (Outside of the Box) */}
          <div className="flex justify-center mt-6 w-full">
            {showButton && (
              <LinkButton
                to="/couple-holidays"
                btnDescription="View All Deals"
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CoupleSlider;
